<template>
  <v-card>
    <v-card-title primary-title class="warning lighten-2">
      {{ label }}
    </v-card-title>
    <v-card-text class="pt-2">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-center">ประเภทภาษา Type of Language</th>
              <th class="text-center">การพูด</th>
              <th class="text-center">การอ่าน</th>
              <th class="text-center">การเขียน</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>อังกฤษ English</td>
              <td class="text-center">
                <v-radio-group
                  d-flex
                  justify-center
                  row
                  v-model="$store.state.dataFrm.list_Special.lan_en_speak"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_en_read"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_en_write"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
            </tr>
            <tr>
              <td>จีน Chinese</td>
              <td class="text-center">
                <v-radio-group
                  d-flex
                  justify-center
                  row
                  v-model="$store.state.dataFrm.list_Special.lan_ch_speak"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_ch_read"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_ch_write"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
            </tr>
            <tr>
              <td>ญี่ปุ่น Japanese</td>
              <td class="text-center">
                <v-radio-group
                  d-flex
                  justify-center
                  row
                  v-model="$store.state.dataFrm.list_Special.lan_jp_speak"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_jp_read"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_jp_write"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
            </tr>
            <tr>
              <td>
                <v-text-field
                class="mt-3"
                  v-model="$store.state.dataFrm.list_Special.lan_ot_name"
                  label="อื่น ๆ Other"
                  outlined
                  dense
                ></v-text-field>
              </td>
              <td class="text-center">
                <v-radio-group
                  d-flex
                  justify-center
                  row
                  v-model="$store.state.dataFrm.list_Special.lan_ot_speak"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_ot_read"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
              <td class="text-center">
                <v-radio-group
                  row
                  d-flex
                  justify-center
                  v-model="$store.state.dataFrm.list_Special.lan_ot_write"
                >
                  <v-radio label="ดีมาก" value="1"></v-radio>
                  <v-radio label="ดี" value="2"></v-radio>
                  <v-radio label="พอใช้" value="3"></v-radio>
                </v-radio-group>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      <v-divider></v-divider>
      <v-row class="pt-2">
        <v-col cols="12" md="6" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.list_Special.typing_eng"
            label="พิมพ์ดีดภาษาไทย (คำ:นาที)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.list_Special.typing_th"
            label="พิมพ์ดีดภาษาอังกฤษ (คำ:นาที)"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.list_Special.com_skill"
            label="ความสามารถด้านคอมพิวเตอร์"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="6" class="pt-0 pb-0">
          <v-text-field
            v-model="$store.state.dataFrm.list_Special.other"
            label="ความสามารถอื่นๆ"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <!-- {{$store.state.dataFrm.list_Special}} -->
  </v-card>
</template>
<script>
// import datetimepicker_TH from "./datetimepickerTH";
export default {
  data() {
    return {
      list_lan: [
        {
          name: "อังกฤษ English",
        },
        {
          name: "จีน Chinese",
        },
        {
          name: "ญี่ปุ่น Japanese",
        },
        {
          name: "อื่น ๆ Other",
        },
      ],
    };
  },
  components: {
    // datetimepicker_TH,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
  },
  computed: {},
};
</script>
<style scoped>
.flex-center {
  display: flex;
  justify-content: center;
}
</style>
